// extracted by mini-css-extract-plugin
module.exports = {"scrollableContent":"ScrollableContent_scrollableContent__2T5Sy"};